//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/TaggedObjectCollection.js";
import "../no/Part.js";
let d=[[],[[["journal_identifier"],"FindObject",{R_:{found:"CutView"}},1,0],[["view"],"UpdateCutView",{},1,0],[["view"],"DeleteCutView",{},1,0],[["view"],"CreateLinkedSectionView",{R_:{linked_view:"ModelingView"}},1,0],[["body"],"IsCutBody",{R_:{isCutBody:''}},1,0],[["body","view","uncutBody"],"IsCutBodyOfView",{R_:{isCutBody:''}},2,0],[["body","view","cutBody"],"IsUncutBodyOfView",{R_:{isUncutBody:''}},2,0],[["body"],"IsToolBody",{R_:{isToolBody:''}},1,0],[["body","numCutViews"],"GetCutViewsOfObject",{R_:{cutViews:"DisplayableObject[]"}},1,0]],[]];
SPLM.CutViewCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.CutViewCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

export default SPLM;